import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import RouterContext from "../../context/RouterContext";
import {updateSeduta} from "./Utils";
import "../../final.css";
import { useNavigate } from "react-router-dom";
import {properties} from "../../utils/properties";
import axios from 'axios';
import {ThreeDots} from 'react-loader-spinner';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { v4 as uuidv4 } from 'uuid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import PreviewIcon from '@mui/icons-material/Preview';
import { Editor } from '@tinymce/tinymce-react';
import Modal from '@mui/material/Modal';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import HttpsIcon from '@mui/icons-material/Https';
import NoEncryptionGmailerrorredIcon from '@mui/icons-material/NoEncryptionGmailerrorred';
import Chip from '@mui/material/Chip';
import DoneIcon from '@mui/icons-material/Done';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

// TABELLE: funzioni locali (prima in TabelleScheda.js)
// TABELLE: completa le righe delle tabelle della scheda con celle vuote.
// Prima le celle senza valore non venivano create: le righe risultavano più corte
// (sfondo verde interrotto) e un valore dopo una cella vuota finiva nella colonna precedente.
// Le colonne lette sono le stesse di sempre (3-6): qui si aggiunge solo la cella mancante.

const vuoto = (v) => v === undefined || v === null || String(v).trim() === "";

// Ultima colonna (3-6) che contiene almeno un valore, esclusa la riga STRUCT.
function ultimaColonnaUsata(table) {
    let ultima = 3;
    (table || []).forEach((riga) => {
        if (!riga || riga[2] === "STRUCT") return;
        for (let c = 4; c <= 6; c++) {
            if (!vuoto(riga[c]) && c > ultima) ultima = c;
        }
    });
    return ultima;
}

// Cella vuota con lo stesso stile della riga. Non aggiunge nulla per la riga STRUCT,
// per le righe completamente vuote (separatori) e oltre l'ultima colonna usata.
function cellaVuota(table, subitem, col) {
    if (!subitem || subitem[2] === "STRUCT") return null;
    const ultima = ultimaColonnaUsata(table);
    if (col > ultima) return null;
    let rigaVuota = true;
    for (let c = 3; c <= ultima; c++) {
        if (!vuoto(subitem[c])) rigaVuota = false;
    }
    if (rigaVuota) return null;
    // stessi colori delle celle piene: verde per righe di totale/intestazione, bianco per le altre
    const verde = subitem[1] === "0" || subitem[1] === "" || subitem[0] === "-99" ||
                  (subitem[2] === "HEAD" && subitem[1] !== "2");
    return (
        <td key={"vuota-" + col}
            style={verde
                ? { background: "#bcf3a1", fontSize: "16px", paddingTop: "15px" }
                : { background: "white", fontSize: "16px" }} />
    );
}

export default function DettaglioCardEditing() {
    let {dataSeduta, faseSeduta, idScheda, refname } = useParams();
    const [loading, setLoading]= React.useState(true);  
    const [finalInfo, setFinalInfo] = useState([]);    
    const navigate = useNavigate();
    const { pageRouter, setPageRouter } = useContext(RouterContext);    
    const meetingId = dataSeduta;  
    //const [color, setColor] = useState([]);
    const [editorContent, setEditorContent] = useState('');
    
    const [tableContent, setTableContent] = useState('');
    const [openTable, setOpenTable] = useState(false);

    const [itemContent, setItemContent] = useState('');
    const [commentContent, setCommentContent] = useState('');
    const [open, setOpen] = useState(false);
    const [openedLabel, setOpenedLabel]= useState(null);
    const [openRelazione, setOpenRelazione] = useState(false);
    //
    const [praticaBloccataOriginalField, setPraticaBloccataOriginalField] = useState('');
    const [praticaBloccata, setPraticaBloccata] = useState(false);
    const [praticaUltimaModifica, setPraticaUltimaModifica] = useState('');
    const [praticaModificataDa, setPraticaModificataDa] = useState('');
    //
    
    // PRONTA: con la scheda PRONTA PER IL COMITATO non si modifica e non si nasconde nulla (come in CardEditing)
    const MSG_PRONTA = "La scheda è PRONTA PER IL COMITATO: per modificarla rimetterla in preparazione.";

    const handleCloseRelazione = () => {    
        console.log("Close:", editorContent);            
        setOpenRelazione(false);
    };
    const handleSaveRelazione = () => {
        if (praticaBloccata) { window.alert(MSG_PRONTA); return; } // PRONTA
        if (!loading) { setLoading(true);}   
        doPostUpdate (idScheda, itemContent.originalField, "newValue",editorContent);  
        console.log("Salvato:", editorContent, itemContent);                  
        setOpenRelazione(false);
      };
    const handleOpenRelazione = (val) => {        
        if (praticaBloccata) { window.alert(MSG_PRONTA); return; } // PRONTA
        console.log("HO",val);
        let v = val.newValue || val.value;        
        setItemContent(val);        
        setEditorContent(v || '');        
        setOpenRelazione(true);
    };

    const handleEditorCommentChange = (content, editor) => {
        setCommentContent(content);
    };

    const handleEditorChange = (content, editor) => {
        setEditorContent(content);
    };

    const handleClose = () => {    
        console.log("Close:", editorContent);    
        setCommentContent('');  
        setOpenedLabel(null)
        setOpen(false);
    };

    // PRONTA: lo stato cambia solo dopo la conferma del server; in caso di errore resta com'era (come in CardEditing)
    const handleClickFabLock = async (event) => {        
            console.log("handleClickFabLock",event);  
            if (!praticaBloccataOriginalField) {
                window.alert("Impossibile cambiare lo stato: la scheda non contiene il campo 'Bloccato'.");
                return;
            }
            const nuovoStato = !praticaBloccata;
            try {
                await doPostUpdatePromise(idScheda, praticaBloccataOriginalField, "newValue", String(nuovoStato), true);
                setPraticaBloccata(nuovoStato);
            } catch (err) {
                console.error("Errore nel cambio di stato", err);
                window.alert("Non è stato possibile cambiare lo stato della scheda. Riprovare.");
            }
    };  

    const handleSave = () => {
        if (praticaBloccata) { window.alert(MSG_PRONTA); return; } // PRONTA
        if (!loading) { setLoading(true);}   
        doPostUpdate (idScheda, itemContent.originalField, "newValue",editorContent);  
        console.log("Salvato:", editorContent, itemContent);            
        doPostUpdate (idScheda, itemContent.originalField, "comment",commentContent);  
        setCommentContent('');     
        setOpenedLabel(null)   
        setOpen(false);
      };

    const onClickToUpdate= (e ) => {   
        navigate("/schede/"+ idScheda);
    };


    const handleOpen = (val) => {        
        if (praticaBloccata) { window.alert(MSG_PRONTA); return; } // PRONTA
        console.log("HO",val);
        let v = val.newValue || val.value;    
        setOpenedLabel(val.label);    
        setItemContent(val);        
        setEditorContent(v || '');
        setCommentContent(val.comment||'');
        setOpen(true);
      };



    const handleOpenTable = (val) => {        
        if (praticaBloccata) { window.alert(MSG_PRONTA); return; } // PRONTA
        console.log("HTO",val);
        //let v = val.table;    
        setOpenedLabel(val.label);    
        setItemContent(val);        
        console.log("EEEEEEEE",itemContent, val);
        //setTableContent(v || '');
        setCommentContent(val.comment||'');
        setOpenTable(true);
        
      };


    const handleCloseTable = () => {    
        //console.log("Close:", editorContent);    
        setCommentContent('');  
        setOpenedLabel(null)
        setOpenTable(false);
    };

    const handleSaveTable = () => {
        if (praticaBloccata) { window.alert(MSG_PRONTA); return; } // PRONTA
        if (!loading) { setLoading(true);}                   
        doPostUpdate (idScheda, itemContent.originalField, "comment",commentContent);  
        setCommentContent('');     
        setOpenedLabel(null)   
        setOpenTable(false);
      };


    const handleHide = (val) => {    
        if (praticaBloccata) { window.alert(MSG_PRONTA); return; } // PRONTA
        if (!loading) { setLoading(true);}   
        console.log("HIDINIG",val);
        doPostUpdate (idScheda, val.originalField, "hide",false);  
        console.log("HIDE",val.originalField, idScheda);        
        };

    const updateUI = function(jsonData) {
        if( properties.verboseLog==1)             
            console.log("31",jsonData, refname, dataSeduta, idScheda);    
        var items = [];                  
                
        var objectInterest="";
        if( properties.verboseLog==1)
            console.log("test",Object.entries(jsonData.components).length);
        for (var ind = 0; ind < Object.entries(jsonData.components).length; ind++) {
            if(Object.entries(jsonData.components)[ind][0] == refname)
            objectInterest=Object.entries(jsonData.components)[ind][1];
        }
                
        const finalList = Object.entries(objectInterest.fields);
        if( properties.verboseLog==1)
            console.log("qq41",finalList);
               
        for (var i = 0; i < finalList.length; i++) {    

            var item = {
                label: finalList[i][1]["label"],
                value: finalList[i][1]["value"],
                style: finalList[i][1]["style"],
                second: finalList[i][1]["secondValue"],
                comment: finalList[i][1]["comment"],
                reftype: refname,
                originalField:finalList[i][0],
                table: finalList[i][1]["table"],
                newValue:finalList[i][1]["newValue"],
                hide:finalList[i][1]["hide"],
                componentRef: finalList[i][1]["componentRef"],            
            };
            if( properties.verboseLog==1)
                console.log("Q1",item);
            items.push(item);
        }
        
        setFinalInfo(items);
        //if( properties.verboseLog==1)
            console.log("Q1Q2",items);
        
        //
        const appoggioFieldsItem = Object.entries(jsonData.components.appoggio.fields);
        
        for (var i = 0; i < appoggioFieldsItem.length; i++) {                        
            if(appoggioFieldsItem[i][1]["label"]=="Ultima modifica"){            
                //console.log("WWW",appoggioFieldsItem[i][1]);
                const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                console.log("UM",valZ);
                if(valZ=='None')
                    setPraticaUltimaModifica("");
                else
                    setPraticaUltimaModifica(valZ);
                //setPraticaUltimaModificaOriginalField(appoggioFieldsItem[i][0]);
            }    
            if(appoggioFieldsItem[i][1]["label"]=="Modificato da"){                    
                const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                console.log("MD",valZ,appoggioFieldsItem);
                if(valZ=='None')
                    setPraticaModificataDa("");
                else
                    setPraticaModificataDa(valZ);
                //setPraticaModificataDaOriginalField(appoggioFieldsItem[i][0]);
            }    
            if(appoggioFieldsItem[i][1]["label"]=="Bloccato"){                    
                const valZ=appoggioFieldsItem[i][1].newValue||appoggioFieldsItem[i][1].value;
                console.log("BL",valZ);
                if(valZ=='false')
                    setPraticaBloccata(false);
                else
                    setPraticaBloccata(true); 
                setPraticaBloccataOriginalField(appoggioFieldsItem[i][0]);                                       
            }    
        }
        //

        setLoading(false);    
    }

    const doPostSeduta2 = function() {
    
        var xhr2 = new XMLHttpRequest();                        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/checkSchedaPreview.php',true);
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                        console.log("OK93",obj);          
                    if(obj.status==="204" ){ 
                        console.log("OK DETTAGLIOCARD 204",xhr2);  
                        const SchedaInfo = JSON.parse(localStorage.getItem("schedaContent"));
                        updateUI(SchedaInfo);
                    }              
                    else{
                        //status 201
                        console.log("OK DETTAGLIOCARD 201",xhr2);  
                        try{
                            localStorage.setItem("schedaContent", obj.content);
                            localStorage.setItem("scheda", idScheda);
                            localStorage.setItem("schedaVersion", obj.date);                                                                     
                        }
                        catch(error) {
                            console.log("LOCALSTORAGE ISSUE", error);
                        }                        
                        const SchedaInfo = JSON.parse(obj.content);
                        updateUI(SchedaInfo);
                    }
                } 
                else {
                    console.error("Error 1", xhr2.statusText);          
                    window.alert("Errore recuperando la scheda 2");                      
                    navigate("/editor",{ replace: true });     
                }
            }
        };

        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };
    
        //let urlEncodedData = "ids=" + idScheda;
        let urlEncodedData = "ids=" + idScheda+ "&data="+dataSeduta+ "&fase="+faseSeduta;        
        xhr2.send(urlEncodedData);
    }

    const doPostUpdate = function(idScheda, entry, attribute, value) {
    
        var xhr2 = new XMLHttpRequest();                        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/updateSchedaPreview.php',true);
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                        console.log("OK93",obj);          
                    if(obj.status==="201" ){                         
                        console.log("OK CARD 201",xhr2);                                      
                        const SchedaInfo = JSON.parse(obj.content);
                        updateUI(SchedaInfo);
                    }
                } 
                else if (xhr2.status === 423) { // PRONTA: il server rifiuta le modifiche a una scheda PRONTA
                    setLoading(false);
                    setPraticaBloccata(true);
                    window.alert(MSG_PRONTA);
                }
                else {
                    //console.error("Error 1", xhr.statusText);          
                    window.alert("Errore recuperando la scheda 1");                      
                    navigate("/editor",{ replace: true });                      
                }
            }
        };
        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };       
        let encValue= btoa(unescape(encodeURIComponent(value)))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
        
        //console.log("IDDIIO", value, encValue);        
        //let urlEncodedData = "ids=" + idScheda+"&key="+entry+"&attribute="+attribute+"&value="+encodeURIComponent(encValue);
        let urlEncodedData = "ids=" + idScheda + "&data="+dataSeduta+ "&fase="+faseSeduta+ "&key="+entry+"&attribute="+attribute+"&value="+encodeURIComponent(encValue);
        console.log(urlEncodedData);      
        xhr2.send(urlEncodedData);
    }

    // PRONTA: versione con esito, usata dal pulsante PRONTA / IN PREPARAZIONE (stessa di CardEditing)
    const doPostUpdatePromise = function(idScheda, entry, attribute, value, update) {
        return new Promise((resolve, reject) => {
            var xhr2 = new XMLHttpRequest();
            xhr2.open("POST", properties.productionUrl+properties.productionUrlSuffix +"/core/rest/updateSchedaPreview.php", true);
            xhr2.withCredentials = true;
            xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhr2.onload = function () {
                if (xhr2.readyState === 4) {
                    if (xhr2.status === 200) {
                        try {
                            const obj = JSON.parse(xhr2.responseText);
                            if (obj.status === "201") {
                                const SchedaInfo = JSON.parse(obj.content);
                                resolve(obj);
                                if (update)
                                    updateUI(SchedaInfo);
                            } else {
                                reject(obj);
                            }
                        } catch (err) {
                            reject(err);
                        }
                    } else {
                        reject(new Error("HTTP error " + xhr2.status));
                    }
                }
            };
            xhr2.onerror = function () {
                reject(new Error("Network error"));
            };
            let encValue= btoa(unescape(encodeURIComponent(value)))
                .replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=+$/, '');
            let urlEncodedData = "ids=" + idScheda + "&data="+dataSeduta+ "&fase="+faseSeduta+ "&key="+entry+"&attribute="+attribute+"&value="+encodeURIComponent(encValue);
            xhr2.send(urlEncodedData);
        });
    }

    useEffect(() => {        
        updateSeduta(meetingId,doPostSeduta2,updateUI);                                
    }, []);

    return (
        <div> 
        {loading ? (
            <div key={uuidv4()} style={{ width:"25%",   display: "flex", 
            marginLeft: "auto", marginRight: "auto" }}> 
             <ThreeDots color="#30720f" height='350' width='150'/>
             </div> 
        ):(
        <div className="content" key={uuidv4()} >            
            <Tooltip title="Forza aggiornamento" placement="left">
             <Fab aria-label="add"                 
                //variant="contained" 
                onClick={(event) => {onClickToUpdate(event) }}
                
                style={{
                    margin: 0,
                    background: "#30720f",
                    top: 'auto',
                    right: 5,
                    bottom: 90,
                    //color: '0xFF0000',
                    left: 'auto',
                    position: 'fixed',}}>                    
                    <PreviewIcon />
                    
             </Fab>   
            </Tooltip>     
            <Tooltip title={praticaBloccata ? "Abilita modifica" : "Blocca modifica"} placement="left">
                <Fab aria-label="add" onClick={handleClickFabLock}          
                    style={{
                        margin: 0,
                        background: "#F57C00 ",
                        top: 'auto',
                        right: 5,
                        bottom: 25,                    
                        left: 'auto',
                        position: 'fixed',}}>                                            
                        {praticaBloccata ?(
                            <NoEncryptionGmailerrorredIcon />
                        ):(
                            <HttpsIcon />
                        )}                                     
                </Fab>   
            </Tooltip>
            <div className="common-list" key={"007"}
                    style={{ position:"relative", margin: "0px", paddingLeft: "70px",
                             borderRadius: "0px", borderTopLeftRadius:"8px" , borderTopRightRadius: "8px",                                                                
                             borderBottomLeftRadius:"8px" , borderBottomRightRadius: "8px",                                                                
                             borderBottom:  "1px solid #EFEFEF",
                                marginBottom:"5px",                                                                                              
                                backgroundColor:"white",
                                border: "none",                                                                
                                //marginLeft: item.hide ? "50px": "0px"
                            }}                          
                        >
                            {/* PUNTO3: allineamento verticale come in CardEditing (margini dei <p> a 0, chip senza marginTop) */}
                            <div style={{ display:"flex", alignItems:"center", width: "100%", padding: "0px 25px",margin: "5px 0px",
                                            textAlign: "left"}} >
                                        <p className="text importantText" style={{margin: 0}}>
                                           Numero Pratica:
                                        </p>   
                                        <p className="text" style={{margin: 0, paddingLeft:"20px"}}>{idScheda}</p>
                                        {praticaBloccata? (
                                        <Chip style={{marginLeft:"20px", backgroundColor:"#BCF3A1"}}
                                            label="PRONTA PER IL COMITATO"                                            
                                            icon={<DoneIcon />}
                                            
                                        />
                                        ):(
                                            <Chip style={{marginLeft:"20px", backgroundColor:"#F6BD60", color:"black"}}
                                            label="IN PREPARAZIONE"                                            
                                            icon={<DriveFileRenameOutlineIcon />}
                                        />  
                                        )
                                    }
                            </div>
                
                </div>
            {finalInfo.map((item, index) => (                
                <div className="common-list" key={index} style={{          
                      position:"relative", margin: "0px", paddingLeft:"70px", marginBottom:"5px",
                      borderRadius: "0px", borderTopLeftRadius: item.itemcss, borderTopRightRadius: item.itemcss,
                      borderBottom: item.bordercss, backgroundColor: item.hide ?"#f0f0f0" :"white",
                      border: item.hide ?"2px dashed #999": "none", opacity: item.hide ? 0.6: 1 ,                                
                      textDecoration: item.hide ? "line-through" : "none"}} >
                      
                      <div style={{ position: "absolute", top: "25%", left: 4, display: "flex", gap:1 }}>
                      <div style={{ width: 24 }}>
                      {item.label !="Relazione/Annotazioni" && item.label !== "Ragione Sociale" && item.label !== "Denominazione iniziativa" && item.label !== "Ruolo della Compagnia" && item.table == undefined && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true? (
                        //console.log ("RRRRR",item.table?.length),
                            <IconButton size="small" onClick={() => handleOpen(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>        
                      ):
                      item.label !="Relazione/Annotazioni" && item.label !== "Ragione Sociale" && item.label !== "Denominazione iniziativa" && item.label !== "Ruolo della Compagnia" && item.table == undefined && localStorage.getItem("ruolo")=="5" && praticaBloccata!=true ? /* PRONTA */ (
                        //console.log ("RRRRR",item.table?.length),
                            <IconButton size="small" onClick={() => handleOpen(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>        
                      ):
                      item.label !="Relazione/Annotazioni" && item.label !== "Ragione Sociale" && item.label !== "Denominazione iniziativa" && item.label !== "Ruolo della Compagnia" && item.table !== undefined && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true? (
                        //console.log ("RRRRR",item.table?.length),
                            <IconButton size="small" onClick={() => handleOpenTable(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>        
                      ):
                      item.label !="Relazione/Annotazioni" && item.label !== "Ragione Sociale" && item.label !== "Denominazione iniziativa" && item.label !== "Ruolo della Compagnia" && item.table !== undefined && localStorage.getItem("ruolo")=="5" && praticaBloccata!=true ? /* PRONTA */ (
                        //console.log ("RRRRR",item.table?.length),
                            <IconButton size="small" onClick={() => handleOpenTable(item)}>
                                <EditIcon fontSize="small" />
                            </IconButton>        
                      ):



                      item.label =="Relazione/Annotazioni" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true?(
                        <IconButton size="small" onClick={() => handleOpenRelazione(item)}>
                            <EditIcon fontSize="small" />
                        </IconButton>        
                      ):
                      item.label =="Relazione/Annotazioni" && localStorage.getItem("ruolo")=="5" && praticaBloccata!=true /* PRONTA */ ?(
                        <IconButton size="small" onClick={() => handleOpenRelazione(item)}>
                            <EditIcon fontSize="small" />
                        </IconButton>        
                      ):
                      <></>}
                      </div> 
                      <div style={{ width: 24 }}>
                      {item.label !== "Ragione Sociale" &&item.label !== "Denominazione iniziativa" && item.label !== "Ruolo della Compagnia" && localStorage.getItem("ruolo")!="5" && praticaBloccata!=true ? (
                            <IconButton size="small" onClick={() => handleHide(item)}>
                                <VisibilityOffIcon fontSize="small" />
                            </IconButton>          
                      ):
                      item.label !== "Ragione Sociale" &&item.label !== "Denominazione iniziativa" && item.label !== "Ruolo della Compagnia" && localStorage.getItem("ruolo")=="5" && praticaBloccata!=true /* PRONTA */ ? (
                            <IconButton size="small" onClick={() => handleHide(item)}>
                                <VisibilityOffIcon fontSize="small" />
                            </IconButton>          
                      ):
                      <></>}
                      </div> 
                      </div> 


                      {item.reftype !== "relazioneannotazioni" ? (
                    item.table && item.label !== "Allegati" ? (        
                        <div style={{ display: "flex", flexDirection: "column", width:"100%"}}>
                                              
                        <div key={uuidv4()} className="common-list" style={{margin: "0px", borderRadius: "0px", marginBottom:"5px", width:"100%"}}>
                            <table key={uuidv4()} className={[item.label, 'table1'].join(' ')} style={{background: "white",  
                            //borderBottom: "1px solid rgb(239, 239, 239)",
                             }}>
                                <tbody key={uuidv4()}>
                                <tr>                  
                                    { item.newValue|| item.value ? (   
                                              
                                    <td key={uuidv4()} colSpan="4" style={{background: "white" }}>
                                        <div key={uuidv4()}
                                            style={{                                    
                                                textAlign: "left",
                                                //marginTop: "0px",
                                                paddingTop: "0px",                                         
                                                color: "#a2ee7d",                                                
                                                //fontWeight: "bold", 
                                                whiteSpace: 'pre-wrap', 

                                            }}> 
                                                                           
                                            <div className="text importantText" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>                                
                                        </div>                                        
                                    </td>
                                    ):(                                     

                                    <td key={uuidv4()} colSpan="4" style={{background: "white" }}>
                                        <div key={uuidv4()}
                                            style={{                                    
                                            textAlign: "left",  
                                            paddingTop: "10px",                                                                                                                  
                                            whiteSpace: 'pre-wrap',                              
                                            
                                            }}>            
                                              <div className="text importantText" style={{ whiteSpace: 'normal', fontWeight: "normal", }}
                                                dangerouslySetInnerHTML={{ __html: item.label}}/>                                                 
                                        </div>                                        
                                    </td>
                                    )}
                                </tr>
                                </tbody>

                                {item.table.map((subitem, subIndex) =>
                                    subIndex !== 0 || subitem[2] === "DATA" ? ( /* TABELLE: indice della riga, non del campo */                                        
                                        <tbody key={uuidv4()}>
                                        <tr key={uuidv4()}>
                                            { subitem[1] === "2" && subitem[3] ?
                                            (
                                               //console.log("sub1",subitem), 
                                            <td key={uuidv4()}
                                            style={{
                                                textAlign: "left",
                                                fontSize: "16px",
                                                color: "#879497",
                                                fontWeight:"normal",
                                                background: "white", 
                                                
                                                //background: "red", 
                                                }}>{subitem[3]}
                                            </td>
                                            ) : [ subitem[1] === "0" && subitem[3] ? (
                                            //console.log("sub2",subitem),
                                            
                                            <td key={uuidv4()}
                                            style={{ 
                                                textAlign: "left",
                                                fontSize: "16px",
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}> {subitem[3]}</td>
                                            ): [ subitem[1] === "" && subitem[3] && subitem[2]!== "STRUCT" ? (
                                            //console.log("sub3",subitem),
                                            <td key={uuidv4()}
                                            style={{                                                 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                fontSize: "16px",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}> {subitem[3]}</td>
                                            ): [ subitem[3] && subitem[2]!== "STRUCT" ? 
                                            (
                                            //console.log("sub4",subitem),
                                            <td key={uuidv4()}
                                            style={{
                                                textAlign: "left",
                                                fontSize: "16px",
                                                background: "white", 
                                                fontWeight:"normal", 
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                 }}>{subitem[3]}</td>
                                            ) : [subitem[0]=== "-99" || subitem[2]=== "HEAD" ? 
                                            (
                                            //console.log("sub5",subitem),
                                            <td key={uuidv4()}
                                            style={{ 
                                                textAlign: "left",
                                                fontSize: "16px",
                                                //background: "#ffeeef",
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[3]}</td>
                                            ): 
                                             cellaVuota(item.table, subitem, 3) /* TABELLE */]
                                            ]]]}        

                                            { subitem[1] === "2" && subitem[4] ?
                                            (

                                            <td key={uuidv4()}
                                            style={{
                                                color: "#879497",
                                                fontSize: "16px",
                                                background: "white",
                                                fontWeight:"normal", }}>{subitem[4]}</td>
                                            ) : [ subitem[1] === "0" && subitem[4] ? (
                                            
                                            <td key={uuidv4()}
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                fontSize: "16px",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[4]}</td>
                                            ): [ subitem[1] === "" && subitem[4] && subitem[2]!== "STRUCT" ? (
                                            
                                            <td key={uuidv4()}
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                fontSize: "16px",
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[4]}</td>
                                            ): [ subitem[4] && subitem[2]!== "STRUCT" ? 
                                            (
                                            <td key={uuidv4()}
                                            style={{
                                                background: "white", 
                                                //color: "#4B0307", 
                                                fontSize: "16px",
                                                color: "#000000", 
                                                fontWeight:"normal", }}>{subitem[4]}</td>
                                            ) : 
                                            [ subitem[0]=== "-99" || subitem[3]=== "Questionario di approfondimento" ||subitem[2] === "HEAD" ? 
                                            (
                                            //console.log("qui", subitem),
                                            <td key={uuidv4()}
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                fontSize: "16px",
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[4]}</td>
                                            ): cellaVuota(item.table, subitem, 4) /* TABELLE */]
                                            ]]]}                                                 
                                                   { subitem[1] === "2" && subitem[5] ?
                                            (
                                           
                                            <td key={uuidv4()}
                                            style={{
                                                color: "#879497",
                                                fontSize: "16px",
                                                background: "white",
                                                fontWeight:"normal", }}>{subitem[5]}</td>
                                            ) : [ subitem[1] === "0" && subitem[5] ? (
                                           
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[5]}</td>
                                            ): [ subitem[1] === "" && subitem[5] && subitem[2]!== "STRUCT" ? (
                                           
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                fontSize: "16px",
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[5]}</td>
                                            ): [ subitem[5] && subitem[2]!== "STRUCT" ? 
                                            (
                                            <td key={uuidv4()} 
                                            style={{
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                fontWeight:"normal",
                                                background: "white", }}>{subitem[5]}</td>
                                            ) : [  (subitem[0]=== "-99"  || (subitem[2] === "HEAD" && subitem[3] !== "Domanda")) && ultimaColonnaUsata(item.table) >= 5 /* TABELLE: niente cella di intestazione oltre l'ultima colonna usata */ ? 
                                            (
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[5]}</td>
                                            ): cellaVuota(item.table, subitem, 5) /* TABELLE */]
                                            ]]]}                               


                                            { subitem[1] === "2" && subitem[6] ?
                                            (                                           
                                            <td key={uuidv4()} 
                                            style={{
                                                color: "#879497",
                                                background: "white",
                                                fontSize: "16px",
                                                fontWeight:"normal", }}>{subitem[6]}</td>
                                            ) : [ subitem[1] === "0" && subitem[6] ? (
                                           
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                fontSize: "16px",
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[6]}</td>
                                            ): [ subitem[1] === "" && subitem[6] && subitem[2]!== "STRUCT" ? (
                                           
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[6]}</td>
                                            ): [ subitem[6] && subitem[2]!== "STRUCT" ? 
                                            (
                                            <td key={uuidv4()} 
                                            style={{
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                background: "white",
                                                fontWeight:"normal", }}>{subitem[6]}</td>
                                            ) : [ subitem[6] && subitem[0]=== "-99" ? 
                                            (
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[6]}</td>
                                            ):
                                            cellaVuota(item.table, subitem, 6) /* TABELLE */]
                                            ]]]}                                                                                                                                    
                                        </tr>
                                        </tbody>
                                    ) : (
                                        <></>
                                    )
                                )}                                
                            </table>                            
                        </div>
                        
                        <div className="common-list" style={{width:"100%"}}>
                        {item.comment ? (  
                            //console.log("cmt4", item.comment),                              
                                <div key={uuidv4()} style={{                                        
                                        textAlign: "left",
                                        background: "white",
                                        padding: "25px 25px",                                                                                
                                        width:"100%",
                                        marginRight:"50px",
                                        //margin: "40px 0px",
                                    }}>                                                                        
                                    <div key={uuidv4()}
                                        style={{
                                            background: "white",
                                            //color: "#879497",
                                            padding: "0px 25px",
                                            //border: "1px solid #FEADB0",
                                            border: "1px solid #30720f",
                                            borderRadius: "20px",
                                            margin: "0px 0px",
                                            marginBottom:"5px",
                                            
                                            width:"100%"
                                        }}>
                                        <p className="text notImportantText">
                                            Commento:
                                        </p>
                                        <div className="text notImportantText" style={{ whiteSpace: 'normal' }}
                                                        dangerouslySetInnerHTML={{ __html: item.comment}}/>                                        
                                    </div>
                                </div>
                            ): (
                            <></>
                            )}
                        </div>
                      </div>  
                    ) : item.label === "Allegati" ? (                                          
                        <div key={uuidv4()}
                            //key={index}
                            style={{
                                textAlign: "left",
                                paddingLeft: "25px",
                                paddingRight: "25px",
                                background: "white",
                                paddingTop: "20px",
                                //borderBottom: "1px solid rgb(239, 239, 239)",
                                width:"100%"
                            }}>
                            <p className="text importantText"
                                style={{
                                    //color: "rgb(254, 173, 176)",
                                    //fontWeight: "bold",
                                    marginTop: "0px",
                                }}> {item.label}: </p>
                            <div key={uuidv4()}
                                style={{
                                    //paddingBottom: "20px",
                                    //color: "rgb(75, 3, 7)",
                                    color: "#30720f",
                                    whiteSpace: 'pre-wrap',
                                }}>                                
                                     <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>   

                            </div>
                            {item.table ? (
                                item.table.map((extraitem, index) =>(    

                                index !== 0 && extraitem[3] !== 'Nome Allegato'? (
                                //console.log(extraitem[3]),
                                    <div
                                        key={index}
                                        style={{
                                            //paddingBottom: "20px",
                                            //color: "rgb(75, 3, 7)",
                                            color: "#30720f",
                                        }}>

                                    <div className="text " style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: extraitem[3]}}/>                                       
                                    </div>
                                        ) : (
                                            <></>
                                        )
                                ))
                            ) : (
                                <></>
                            )}
                        </div>                      
                    ): item.comment ? (                                            
                        <div key={uuidv4()}
                                    style={{
                                        textAlign: "left",
                                        paddingLeft: "25px",
                                        paddingRight: "25px",
                                        background: "white",
                                        paddingTop: "20px",                                
                                        //borderBottom: "1px solid rgb(239, 239, 239)",
                                        width:"100%"
                                    }}>                                
                                    <div key={uuidv4()}>
                                        <p className="text importantText"
                                        //style={{ color: "#FEADB0" }}
                                        >
                                            {item.label}:
                                        </p>
                                        <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>                                    
                                    </div>
                                    <div key={uuidv4()}
                                        style={{
                                            color: "#879497",
                                            padding: "0px 25px",
                                            //border: "1px solid #FEADB0",
                                            border: "1px solid #30720f",
                                            borderRadius: "20px",
                                            margin: "40px 0px",
                                            //marginBottom:"5px"
                                        }}
                                    >
                                        <p className="text notImportantText"
                                        //style={{ fontWeight: "bold" }}
                                        >
                                            Commento:
                                        </p>                                        
                                        <div className="text notImportantText" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.comment}}/>       
                                        
                                    </div>
                        </div>                        
                    ) : item.style === 1  ? (             //AD ESEMPIO PER RUOLO COMPAGNIA IN SCHEDA INIZIATIVA     d                                
                        // PUNTO3: stesso stile di "Elementi di valutazione" in CardEditing
                        // (niente margine inferiore interno che lasciava una striscia bianca, spazio sotto il testo, etichetta classe "text")
                        <div key={uuidv4()}
                                    style={{
                                        //background: "#FEADB0",
                                        background: "#a2ee7d",
                                        color: "#4B0307",
                                        textAlign: "left",
                                        padding: "0px 25px",
                                        border: "1px solid rgb(239, 239, 239)",    
                                        paddingBottom:"20px",
                                        width:"100%"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            
                                        }}
                                    >
                                        <p className="text"                                            
                                        >
                                            {item.label}: 
                                        </p>
                                    </div>                                    
                                    <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>   
                        </div>                        
                    ) : (                                                                
                        <div key={uuidv4()}                        
                                //key={index}
                                style={{
                                    textAlign: "left",
                                    paddingLeft: "25px",
                                    paddingRight: "25px",
                                    background: "white",
                                    paddingTop: "20px",
                                    //paddingBottom:"0px",      
                                    //backgroundColor:"red",                      
                                    //borderBottom: "1px solid rgb(239, 239, 239)",
                                    marginBottom:"5px",
                                    width:"100%"
                                }}>
                                    
                            <p className="text importantText"
                                style={{
                                    //color: "rgb(254, 173, 176)",
                                    //fontWeight: "bold",
                                    marginTop: "0px",                                    
                                }}
                            >                            
                                {item.label}:
                            </p>

                            <div key={uuidv4()}
                                style={{
                                    paddingBottom: "10px",
                                    //color: "rgb(75, 3, 7)",
                                    color: "#30720f",
                                    whiteSpace: 'pre-wrap',
                                }} > 
                                <div className="text" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}}/>
                                </div>
                        </div>
                        
                    )             
                ) : (                        
                    <div key={uuidv4()}  style={{ textAlign: "left", paddingLeft: "25px", paddingRight: "25px",
                        background: "white", paddingTop: "20px", borderBottom: "1px solid rgb(239, 239, 239)", width:"100%"}} >
                        <p className="text importantText" style={{ marginTop: "0px"}}>
                            {item.label}:
                        </p>
                        <div style={{ paddingBottom: "10px", color: "black", whiteSpace: 'normal' }}
                            dangerouslySetInnerHTML={{ __html: item.newValue || item.value}} />
                        {item.table ? (
                            item.table.map((extraitem, index) => (                            
                            <div key={index} style={{ paddingBottom: "10px" }}
                                dangerouslySetInnerHTML={{ __html: extraitem[3] }}/>
                            ))
                        ) : (
                            <></>
                        )}
                    </div>                    
                )}                            
                </div>
        
        ))}
        {praticaUltimaModifica != '' || praticaModificataDa !='' ?(
            <p>
            Ultima modifica sulla pratica effettuata il:<strong> {praticaUltimaModifica} </strong>, dall'utente: <strong> {praticaModificataDa} </strong> 
            </p>          
        ):(<></>)}
        </div>
     )}
     
     
     <Modal
        open={open}
        keepMounted={false} 
        onClose={handleClose}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        disableEnforceFocus
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica {openedLabel}</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>         
             <Editor   value={editorContent}
                       onEditorChange={handleEditorChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
              }}/>
               <Accordion sx={{ boxShadow: "none", backgroundColor: "transparent"}} >
                            <AccordionSummary >
                                <Typography fontSize={14} color="#777">
                                    Mostra valore originale
                                </Typography>
                            </AccordionSummary>

                            <AccordionDetails>
                                <div className="text" style={{ whiteSpace: 'normal',color:"#aaa", fontStyle: "italic",paddingTop:"10px" }}
                                            dangerouslySetInnerHTML={{ __html: itemContent.value}}/>   
                            </AccordionDetails>
                        </Accordion> 

          </div>
          <h2 id="edit-modal-title">Commento</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>           
             <Editor   value={commentContent}
                       onEditorChange={handleEditorCommentChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
          </div>

          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleClose} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSave} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>

       
     <Modal
        open={openRelazione}
        keepMounted={false} 
        onClose={handleCloseRelazione}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        disableEnforceFocus
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica Relazione/Annotazioni</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>         
             <Editor   value={editorContent}
                       onEditorChange={handleEditorChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
          </div>         

          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseRelazione} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveRelazione} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>

         
      <Modal
        open={openTable}
        keepMounted={false} 
        onClose={handleCloseTable}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
        disableEnforceFocus
      >
        <div
          style={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            width: '90%',
            height: '90%',
            backgroundColor: 'white',
            padding: '20px',
            overflow: 'auto',
            boxShadow: 24,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 id="edit-modal-title">Modifica {openedLabel}</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>      
                    {itemContent.table != undefined ?(                        
                            <table key={uuidv4()} className={[itemContent.label, 'table1'].join(' ')} style={{background: "white",  
                            //borderBottom: "1px solid rgb(239, 239, 239)",
                             }}>
                                <tbody key={uuidv4()}>
                                <tr>                  
                                    { itemContent.newValue|| itemContent.value ? (   
                                              
                                    <td key={uuidv4()} colSpan="4" style={{background: "white" }}>
                                        <div key={uuidv4()}
                                            style={{                                    
                                                textAlign: "left",
                                                //marginTop: "0px",
                                                paddingTop: "0px",                                         
                                                color: "#a2ee7d",                                                
                                                //fontWeight: "bold", 
                                                whiteSpace: 'pre-wrap', 

                                            }}> 
                                                                           
                                            <div className="text importantText" style={{ whiteSpace: 'normal' }}
                                            dangerouslySetInnerHTML={{ __html: itemContent.newValue || itemContent.value}}/>                                
                                        </div>                                        
                                    </td>
                                    ):(                                     

                                    <td key={uuidv4()} colSpan="4" style={{background: "white" }}>
                                        <div key={uuidv4()}
                                            style={{                                    
                                            textAlign: "left",  
                                            paddingTop: "10px",                                                                                                                  
                                            whiteSpace: 'pre-wrap',                              
                                            
                                            }}>            
                                              <div className="text importantText" style={{ whiteSpace: 'normal', fontWeight: "normal", }}
                                                dangerouslySetInnerHTML={{ __html: itemContent.label}}/>                                                 
                                        </div>                                        
                                    </td>
                                    )}
                                </tr>
                                </tbody>
                                
                                {itemContent.table.map((subitem, subIndex) =>
                                    subIndex !== 0 || subitem[2] === "DATA" ? (                                        
                                        <tbody key={uuidv4()}>
                                        <tr key={uuidv4()}>
                                            { subitem[1] === "2" && subitem[3] ?
                                            (
                                               //console.log("sub1",subitem), 
                                            <td key={uuidv4()}
                                            style={{
                                                textAlign: "left",
                                                fontSize: "16px",
                                                color: "#879497",
                                                fontWeight:"normal",
                                                background: "white", 
                                                
                                                //background: "red", 
                                                }}>{subitem[3]}
                                            </td>
                                            ) : [ subitem[1] === "0" && subitem[3] ? (
                                            //console.log("sub2",subitem),
                                            
                                            <td key={uuidv4()}
                                            style={{ 
                                                textAlign: "left",
                                                fontSize: "16px",
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}> {subitem[3]}</td>
                                            ): [ subitem[1] === "" && subitem[3] && subitem[2]!== "STRUCT" ? (
                                            //console.log("sub3",subitem),
                                            <td key={uuidv4()}
                                            style={{                                                 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                fontSize: "16px",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}> {subitem[3]}</td>
                                            ): [ subitem[3] && subitem[2]!== "STRUCT" ? 
                                            (
                                            //console.log("sub4",subitem),
                                            <td key={uuidv4()}
                                            style={{
                                                textAlign: "left",
                                                fontSize: "16px",
                                                background: "white", 
                                                fontWeight:"normal", 
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                 }}>{subitem[3]}</td>
                                            ) : [subitem[0]=== "-99" || subitem[2]=== "HEAD" ? 
                                            (
                                            //console.log("sub5",subitem),
                                            <td key={uuidv4()}
                                            style={{ 
                                                textAlign: "left",
                                                fontSize: "16px",
                                                //background: "#ffeeef",
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[3]}</td>
                                            ): 
                                             cellaVuota(itemContent.table, subitem, 3) /* TABELLE */]
                                            ]]]}        

                                            { subitem[1] === "2" && subitem[4] ?
                                            (

                                            <td key={uuidv4()}
                                            style={{
                                                color: "#879497",
                                                fontSize: "16px",
                                                background: "white",
                                                fontWeight:"normal", }}>{subitem[4]}</td>
                                            ) : [ subitem[1] === "0" && subitem[4] ? (
                                            
                                            <td key={uuidv4()}
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                fontSize: "16px",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[4]}</td>
                                            ): [ subitem[1] === "" && subitem[4] && subitem[2]!== "STRUCT" ? (
                                            
                                            <td key={uuidv4()}
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                fontSize: "16px",
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[4]}</td>
                                            ): [ subitem[4] && subitem[2]!== "STRUCT" ? 
                                            (
                                            <td key={uuidv4()}
                                            style={{
                                                background: "white", 
                                                //color: "#4B0307", 
                                                fontSize: "16px",
                                                color: "#000000", 
                                                fontWeight:"normal", }}>{subitem[4]}</td>
                                            ) : 
                                            [ subitem[0]=== "-99" || subitem[3]=== "Questionario di approfondimento" ||subitem[2] === "HEAD" ? 
                                            (
                                            //console.log("qui", subitem),
                                            <td key={uuidv4()}
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                fontSize: "16px",
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[4]}</td>
                                            ): cellaVuota(itemContent.table, subitem, 4) /* TABELLE */]
                                            ]]]}                                                 
                                                   { subitem[1] === "2" && subitem[5] ?
                                            (
                                           
                                            <td key={uuidv4()}
                                            style={{
                                                color: "#879497",
                                                fontSize: "16px",
                                                background: "white",
                                                fontWeight:"normal", }}>{subitem[5]}</td>
                                            ) : [ subitem[1] === "0" && subitem[5] ? (
                                           
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[5]}</td>
                                            ): [ subitem[1] === "" && subitem[5] && subitem[2]!== "STRUCT" ? (
                                           
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                fontSize: "16px",
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[5]}</td>
                                            ): [ subitem[5] && subitem[2]!== "STRUCT" ? 
                                            (
                                            <td key={uuidv4()} 
                                            style={{
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                fontWeight:"normal",
                                                background: "white", }}>{subitem[5]}</td>
                                            ) : [  (subitem[0]=== "-99"  || (subitem[2] === "HEAD" && subitem[3] !== "Domanda")) && ultimaColonnaUsata(itemContent.table) >= 5 /* TABELLE: niente cella di intestazione oltre l'ultima colonna usata */ ? 
                                            (
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[5]}</td>
                                            ): cellaVuota(itemContent.table, subitem, 5) /* TABELLE */]
                                            ]]]}                               


                                            { subitem[1] === "2" && subitem[6] ?
                                            (                                           
                                            <td key={uuidv4()} 
                                            style={{
                                                color: "#879497",
                                                background: "white",
                                                fontSize: "16px",
                                                fontWeight:"normal", }}>{subitem[6]}</td>
                                            ) : [ subitem[1] === "0" && subitem[6] ? (
                                           
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                fontSize: "16px",
                                                color: "#000000", 
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[6]}</td>
                                            ): [ subitem[1] === "" && subitem[6] && subitem[2]!== "STRUCT" ? (
                                           
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[6]}</td>
                                            ): [ subitem[6] && subitem[2]!== "STRUCT" ? 
                                            (
                                            <td key={uuidv4()} 
                                            style={{
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                background: "white",
                                                fontWeight:"normal", }}>{subitem[6]}</td>
                                            ) : [ subitem[6] && subitem[0]=== "-99" ? 
                                            (
                                            <td key={uuidv4()} 
                                            style={{ 
                                                //background: "#ffeeef", 
                                                background: "#bcf3a1",
                                                //color: "#4B0307", 
                                                color: "#000000", 
                                                fontSize: "16px",
                                                //fontWeight:"bold", 
                                                fontWeight:"normal",
                                                paddingTop: "15px"}}>{subitem[6]}</td>
                                            ):
                                            cellaVuota(itemContent.table, subitem, 6) /* TABELLE */]
                                            ]]]}                                                                                                                                    
                                        </tr>
                                        </tbody>
                                    ) : (
                                        <></>
                                    )
                                )}                                
                            </table>
                            ):(<></>)}
          </div>         

          <h2 id="edit-modal-title">Commento</h2>
          <div style={{ flex: 1, marginBottom: '16px' }}>           
             <Editor   value={commentContent}
                       onEditorChange={handleEditorCommentChange}
                       init={{ base_url: '/tinymce',
                            suffix: '.min',        
                            license_key: 'gpl',
                            promotion: false,
                            height: 250,
                            menubar: false,
                            statusbar:false,
                            branding: false,
                            plugins: [ 'lists','link'],
                            toolbar: 'bold italic underline | bullist numlist | link | undo redo',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}/>
          </div>

          <div style={{ paddingTop:"10px", textAlign: 'right' }}>
            <button className="button154" onClick={handleCloseTable} style={{ marginRight: 10, width:'100px' }}>Annulla</button>
            <button className="button11" onClick={handleSaveTable} style={{ marginRight: 10, width:'100px' }}>Salva</button>
          </div>
        </div>
      </Modal>


     </div>    
    );
}